// Avatar limits also apply in Observatory's image_uploads.py and player avatar service.
export const maxAvatarUploadBytes = 5 * 1024 * 1024;
